import * as Configuration from './configuration'
import * as Data from './data'
import * as Payments from './payments'
import * as Processes from '@rushplay/processes'
import * as Redux from 'redux'

import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly'
import {postMessagingMiddleware} from './post-messaging-middleware'
import reduxEffectsFetchMiddleware from 'redux-effects-fetch'
import reduxEffectsMiddleware from 'redux-effects'
import reduxMultiMiddleware from 'redux-multi'

/**
 * Creates the redux store & sets up middlewares
 * @param {Object} initialState redux state
 * @returns {Object} Redux store
 */
export function createStore(initialState) {
  return Redux.createStore(
    Redux.combineReducers({
      configuration: Configuration.reducer,
      data: Data.reducer,
      payments: Payments.reducer,
      processes: Processes.reducer,
    }),
    initialState,
    composeWithDevTools(
      Redux.applyMiddleware(
        reduxMultiMiddleware,
        postMessagingMiddleware,
        // Prefills payment stuff
        Payments.createMiddleware({
          briteConfig(state) {
            return Configuration.getBriteConfig(state)
          },
          countryCode(state) {
            return Configuration.getCountryCode(state)
          },
          currency(state) {
            return Configuration.getCurrency(state)
          },
          locale(state) {
            return Configuration.getPaymentsLocale(state)
          },
          language(state) {
            return Configuration.getLanguage(state)
          },
          piqConfig(state) {
            return Configuration.getPiqConfig(state)
          },
          piqkycConfig(state) {
            return Configuration.getPiqKycConfig(state)
          },
          praxisConfig(state) {
            return Configuration.getPraxisConfig(state)
          },
          projsConfig(state) {
            return Configuration.getProjsConfig(state)
          },
          pwclickConfig(state) {
            return Configuration.getPwclickConfig(state)
          },
          nodapayConfig(state) {
            return Configuration.getNodapayConfig(state)
          },
          transferWorldConfig(state) {
            return Configuration.getTransferWorldConfig(state)
          },
          sessionId(state) {
            return Configuration.getToken(state)
          },
          state(state) {
            return state.payments
          },
          userId(state) {
            return Configuration.getUserId(state)
          },
        }),
        reduxEffectsMiddleware,
        reduxEffectsFetchMiddleware
      )
    )
  )
}
